"use client";
import React from "react";
import Link from "next/link";
import Image from "next/image";
import NavMenus from "./navbar/nav-menus";
import logo from "@/assets/img/logo/HTU White Logo.svg";
import HeaderTopArea from "./header-top/header-top-area";
import logo_black from "@/assets/img/logo/HTU Logo.svg";
import HeaderStickyWrapper from "./header-sticky-provider/header-sticky-wrapper";
import OffcanvasButton from "./button/offcanvas-btn";
import { ifArabic, getLocalizedPath } from "@/utils/language";
import { useLanguage } from "@/app/[lang]/client/language-context";

type HeaderOneProps = {
  transparent?: boolean;
  inner?: boolean;
};

export default function HeaderOne(props: HeaderOneProps) {
  const { language } = useLanguage();

  return (
    <>
      <header
        className="header-area tp-header-transparent p-relative"
        style={{
          backgroundColor: props.transparent ? "transparent" : "#fff",
        }}
      >
        <HeaderTopArea />

        <HeaderStickyWrapper>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xxl-1 col-xl-2 col-lg-6 col-md-6 mr-3 col-6">
                <div className="tp-header-logo-1">
                  <Link
                    href={getLocalizedPath("/", language)}
                    aria-label="HTU Home Page"
                  >
                    {props.transparent ? (
                      <Image className="logo-1" src={logo} alt="HTU Logo" />
                    ) : (
                      <Image
                        className="logo-1"
                        src={logo_black}
                        alt="HTU Logo"
                      />
                    )}
                    <Image className="logo-2" src={logo_black} alt="HTU Logo" />
                  </Link>
                </div>
              </div>
              <div className="col-xxl-9 col-xl-8 d-none d-xl-block ">
                <div className={`main-menu text-end`}>
                  <NavMenus transparent={props.transparent} />
                </div>
              </div>
              <div className="col-xxl-2 col-xl-2 col-lg-6 col-md-6 col-6">
                <div className="tp-header-contact d-flex align-items-center justify-content-end">
                  {props.transparent ? (
                    <div className="tp-header-btn d-none d-md-block ml-30">
                      <Link
                        aria-label="Apply Now"
                        href="https://sis.htu.edu.jo/new/"
                        target="_blank"
                      >
                        {ifArabic("تقدّم الآن", "Apply Now")}
                      </Link>
                    </div>
                  ) : (
                    <div className="tp-about-btn d-none d-md-block">
                      <Link
                        aria-label="Apply Now"
                        className={`tp-btn ${
                          props.transparent ? "" : "apply-now-btn"
                        }`}
                        href="https://sis.htu.edu.jo/new/"
                        target="_blank"
                      >
                        {ifArabic("تقدّم الآن", "Apply Now")}
                      </Link>
                    </div>
                  )}
                  <div
                    className={`tp-header-bar d-xl-none ${ifArabic(
                      "mr-30",
                      "ml-30"
                    )}`}
                  >
                    <OffcanvasButton transparent={props.transparent} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </HeaderStickyWrapper>
      </header>

      <div id="offcanvas-sidebar" />
    </>
  );
}
